import React from "react";
import QuestionDto from "../../../models/surveys/questionDto";
import { Input, Segment } from "semantic-ui-react";
import parse from "html-react-parser";
import { useStore } from "../../../Stores/store";

interface Props {
  question: QuestionDto;
  onAnswer: (value: number, response: string) => void;
}

export default function ViewSalary({ question, onAnswer }: Props) {
  const { translationStore } = useStore();
  return (
    <>
      <Segment className={question.isAnswered === false ? "t4-input required" : "t4-input"}>
        <div>{parse(translationStore.questionBody(question))}</div>
        <Input
          className="t4-input-no"
          type="text"
          value={question.userAnswer}
          onChange={(e) => {
            onAnswer(+e.target.value, e.target.value);
          }}
        />
        {/*{question.isAnswered === false && <Message color={"red"}>Required</Message>}*/}
      </Segment>
      <br />
    </>
  );
}
